import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import { previews } from "@/mocks/siteData";

export default function Preview() {
  const [activeId, setActiveId] = useState(previews[0].id);
  const active = previews.find((p) => p.id === activeId) ?? previews[0];

  return (
    <section id="preview" className="bg-background-100 py-16 md:py-24 scroll-mt-20">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal>
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600 uppercase">
              <span className="w-6 h-px bg-primary-400"></span>
              抢先看
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              进入正片前，先看一眼基调
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              这里整理了正式预告、先导片段与剧情片段三类内容，用来判断一部作品的风格是否合口味。
              点选右侧任意条目，左侧会同步展示它的画面与简介，切换即时生效。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-6">
          <Reveal className="lg:col-span-7">
            <div className="bg-foreground-950 rounded-lg overflow-hidden h-full flex flex-col">
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={active.image}
                  alt={`${active.title} 预览画面`}
                  title={`${active.title} 抢先看`}
                  className="w-full h-full object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/20 to-transparent"></div>
                <div className="absolute top-4 left-4 flex items-center gap-2">
                  <span className="px-3 py-1 rounded-full bg-accent-500 text-foreground-950 text-xs font-medium">
                    {active.kind}
                  </span>
                  <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-foreground-950/60 text-background-100 text-xs backdrop-blur-sm">
                    <i className="ri-time-line" aria-hidden="true"></i>
                    {active.duration}
                  </span>
                </div>
              </div>
              <div className="p-6 md:p-8">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50">{active.title}</h3>
                <p className="mt-3 text-sm md:text-base text-background-100/75 leading-relaxed">{active.desc}</p>
                <p className="mt-5 pt-5 border-t border-background-50/15 text-xs text-background-100/55 leading-relaxed">
                  片段仅用于了解作品基调，完整内容与播放方式以实际播放页为准。
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal className="lg:col-span-5" delay={80}>
            <div className="bg-background-50 rounded-lg border border-background-200 divide-y divide-background-200 h-full">
              {previews.map((clip, idx) => {
                const isActive = clip.id === activeId;
                return (
                  <button
                    key={clip.id}
                    onClick={() => setActiveId(clip.id)}
                    className={`w-full flex items-center gap-4 p-4 text-left transition-colors cursor-pointer ${
                      isActive ? "bg-primary-50" : "hover:bg-background-100"
                    }`}
                  >
                    <span
                      className={`w-8 h-8 flex items-center justify-center rounded-md font-heading text-sm font-bold shrink-0 ${
                        isActive ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-500"
                      }`}
                    >
                      {String(idx + 1).padStart(2, "0")}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className={`block text-sm font-medium truncate ${isActive ? "text-primary-700" : "text-foreground-900"}`}>
                        {clip.title}
                      </span>
                      <span className="block text-xs text-foreground-500 mt-0.5">
                        {clip.kind} · {clip.duration}
                      </span>
                    </span>
                    <i
                      className={`shrink-0 ${isActive ? "ri-play-circle-fill text-primary-500" : "ri-play-circle-line text-foreground-300"} text-xl`}
                      aria-hidden="true"
                    ></i>
                  </button>
                );
              })}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}